import { Component, OnInit } from '@angular/core';
import { EditEngagementMemoryServiceService } from '../../edit-engagement-memory-service/edit-engagement-memory-service.service';
import { EngagementManagementService } from 'src/framework/services/engagement-mgmt.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng';
import { NgxSpinnerService } from 'ngx-spinner';
import { LanguageService } from 'src/framework/services/language.service';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';

@Component({
  selector: 'app-engagement-authorization',
  templateUrl: './engagement-authorization.component.html',
  styleUrls: ['./engagement-authorization.component.css']
})
export class EngagementAuthorizationComponent implements OnInit {
  status1: { label: string, id: number };
  status2: { label: string, id: number };;
  engagementStatus: boolean = false;
  engagementDetailsApprovalColumns = [];
  engagementDetailsTableData = [];
  loggedInUser: any;
  isEngagementApprover: boolean = false;
  selectedLanguageId: number;
  selectedAppLanguageJson: any = '';
  islabelLoaded: boolean = false;
  defaultEnglishJson: any;
  isDetailsApproved: boolean = false;
  isDetailsApprover = false;
  isShortUrlExists: boolean = false;
  isInitialDateExist: boolean = false;
  selectedLangStatusJson: any;
  defaultEngStatusJson: any;
  statusLog: any;

  constructor(
    private engagementMemoryService: EditEngagementMemoryServiceService,
    private engagementManagementService: EngagementManagementService,
    private router: Router,
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
    private languageService: LanguageService
  ) {
    this.loadLanguageLabel();
    this.checkEngagementDetailsApproved();
    if (localStorage.getItem("userModel")) {
      this.loggedInUser = JSON.parse(localStorage.getItem("userModel"));
      if (sessionStorage.getItem('engagementData')) {
        let sessionEngObj = JSON.parse(sessionStorage.getItem('engagementData'));
        if (sessionEngObj['statusId'] == 1) {
          this.status1 = { label: this.statusReplacer(1), id: 1 };
          this.status2 = { label: this.statusReplacer(2), id: 2 };
        }
        else if (sessionEngObj['statusId'] == 2) {
          this.status1 = { label: this.statusReplacer(2), id: 2 };
          this.status2 = { label: this.statusReplacer(3), id: 3 };
          this.isEngagementApprover = true;
        } else {
          this.status1 = { label: this.statusReplacer(3), id: 3 };
          this.status2 = { label: this.statusReplacer(2), id: 2 };
        }
      }
      if (this.loggedInUser.isAdmin || this.loggedInUser.rankCode <= 21) {
        this.isEngagementApprover = true;
        this.isDetailsApprover = true;
      }
    }
    this.getEngagementAwaitingApprovals();
    this.getStatusLog();
  }

  ngOnInit(): void {

  }

  updateStatus() {
    if (this.status2.id != 2 || (this.status2.id == 2 && this.isDetailsApproved && this.isShortUrlExists && this.isInitialDateExist)) {
      this.spinner.show();
      let engagement: { EngagementId, StatusName, StatusId } = { EngagementId: 0, StatusName: "", StatusId: 0 };
      engagement.EngagementId = this.engagementMemoryService.getEngagementId();
      if (this.engagementStatus) {
        engagement.StatusName = this.status2.label;
        engagement.StatusId = this.status2.id;
      }
      else {
        engagement.StatusName = this.status1.label;
        engagement.StatusId = this.status1.id;
      }
      this.engagementManagementService.updateEngagementStatus(engagement).subscribe((response) => {
        if (response.responseStatus == 1) {
          this.messageService.add({
            key: "key1",
            summary: this.labelReplacer('Erroroccurredwhileupdatingengagementstatus'),
            detail: "",
            sticky: false,
            severity: 'error'
          });
          this.spinner.hide();
        } else {

          this.engagementMemoryService.resetEngagementMemory();
          this.messageService.add({
            key: "key1",
            summary: this.labelReplacer('Engagementstatusupdatedsucessfully'),
            detail: "",
            sticky: false,
            severity: 'success'
          });
          setTimeout(() => {
            this.spinner.hide();
            this.router.navigate(["/home"], { queryParams: { engagementType: 'active' } });
          }, 3000)
        }
      })
    } else {
      if (!this.isDetailsApproved) {
        this.messageService.add({
          key: "key1",
          summary: 'Warning',
          detail: this.labelReplacer('Pleaseapproveatleastoneengagementname'),
          sticky: false,
          severity: 'error'
        });
      }
      if (!this.isShortUrlExists) {
        this.messageService.add({
          key: "key1",
          summary: 'Warning',
          detail: this.labelReplacer('addshorturl'),
          sticky: false,
          severity: 'error'
        });
      }
      if (!this.isInitialDateExist) {
        this.messageService.add({
          key: "key1",
          summary: 'Warning',
          detail: this.labelReplacer('addInitialDate'),
          sticky: false,
          severity: 'error'
        });
      }
    }
  }

  getEngagementAwaitingApprovals() {
    this.spinner.show();
    this.engagementManagementService.getEngagementAwaitingApprovals(this.engagementMemoryService.getEngagementId()).subscribe((response) => {
      if (response.status == 1) {

      } else {
        if (response.data && response.data.length > 0) {
          if (!this.loggedInUser.isAdmin && this.loggedInUser.rankCode < 13) {
            response.data = response.data.filter(t => t.authorizedBy && t.authorizedBy == this.loggedInUser.userId);
          }
          this.engagementDetailsTableData = response.data.map(t => ({
            "engagementDetailsHistoryId": t.engagementDetailsHistoryId,
            "engagementDetailsId": t.engagementDetailsId,
            "engagementName": t.engagementName,
            "engagementDescription": t.engagementDescription,
            "languageId": t.languageId,
            "languageName": t.language.name
          }));
        }
      }
    })
  }

  approveEngagementDetails(rowData: any) {
    this.spinner.show();
    this.engagementManagementService.approveEngagementDetails(this.engagementMemoryService.getEngagementId(), rowData.engagementDetailsId).subscribe((response) => {
      if (response.status == 1) {
        this.messageService.add({
          key: "key1",
          summary: this.labelReplacer('Erroroccurredwhileapprovingstatus'),
          detail: "",
          sticky: false,
          severity: 'error'
        });

      } else {
        this.engagementDetailsTableData = this.engagementDetailsTableData.filter(t => t.engagementDetailsHistoryId != rowData.engagementDetailsHistoryId)
        this.isDetailsApproved = true;
        this.messageService.add({
          key: "key1",
          summary: this.labelReplacer('Engagementdetailsapprovedsucessfully'),
          detail: "",
          sticky: false,
          severity: 'success'
        });

      }
      this.spinner.hide();
    })
  }

  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishStatusMappings, selectedLangStatusMappings: any;
    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }
      this.languageService.currentData.subscribe(data => {
        this.selectedLanguageId = data.Id
      })
      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishStatusMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangStatusMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangStatusMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangStatusMappings = englishStatusMappings;
            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);

          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangStatusJson = JSON.parse(selectedLangStatusMappings?.languageMappingJSON ?? englishStatusMappings.languageMappingJSON);
          this.defaultEngStatusJson = JSON.parse(englishStatusMappings.languageMappingJSON);

          this.engagementDetailsApprovalColumns = [
            { field: 'engagementName', header: this.labelReplacer('EngagementName') },
            { field: 'engagementDescription', header: this.labelReplacer('Description') },
            { field: 'languageName', header: this.labelReplacer('Language') }
          ]
          this.islabelLoaded = true;
          resolve(1);
        }
        else {

        }
      });
    }).catch(err => {
      console.log(err);
    });
  }

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  checkEngagementDetailsApproved() {
    this.spinner.show()
    this.engagementManagementService.getIsEngagementDetailsApproved(this.engagementMemoryService.getEngagementId()).subscribe((res) => {
      if (res.responseStatus == 1) {
        this.messageService.add({
          key: "key1",
          summary: this.labelReplacer('Erroroccurredwhileupdatingengagementstatus'),
          detail: "",
          sticky: false,
          severity: 'error'
        });
        this.spinner.hide();
      } else {
        this.isDetailsApproved = res.isEngagementDetailsApproved;
        this.isShortUrlExists = res.isShortUrlExists;
        this.isInitialDateExist = res.isInitialDateExist;
        this.spinner.hide();
      }

    })
  }


  statusReplacer(labelKey): string {
    return this.selectedLangStatusJson[labelKey]?.trim() ? this.selectedLangStatusJson[labelKey] ?? 'text not found' : this.defaultEngStatusJson[labelKey] ?? 'text not found';
  }

  getStatusLog() {
    this.languageService.currentData.subscribe((data) => {
      this.engagementManagementService.getEngagementStatusLog(this.engagementMemoryService.getEngagementId(), data.Id,).subscribe(res => {
        if (res.responseStatus == 1) {

        }
        else {
          this.statusLog = res.data;
        }
        this.spinner.hide()
      })
    })
  }


}
